import { defineConfig } from "../config";

export const CDNService = {
  setTypeFamilies,
  getSystemsIcons,
  getSystemsMarkers,
  getPlanningsMarkers,
  getClusterIcon,
};

const { CDNUrl } = defineConfig.CDN_SERVICE;

// The LANSA types (value = code, e.g. PO01S) take the icons of their family (cartello, pensilina...): code -> family,
// kept for the session so the first render after a reload already has it
const FAMILIES_KEY = "alessi.systemTypeFamilies";
let typeFamilies = {};
try { typeFamilies = JSON.parse(sessionStorage.getItem(FAMILIES_KEY)) || {}; } catch (e) { typeFamilies = {}; }

function setTypeFamilies(types = []) {
  typeFamilies = Object.fromEntries((Array.isArray(types) ? types : []).filter(t => t?.value && t?.family).map(t => [t.value, t.family]));
  try { sessionStorage.setItem(FAMILIES_KEY, JSON.stringify(typeFamilies)); } catch (e) { /* only a cache */ }
}

const iconName = (type) => typeFamilies[type] || type;

function getSystemsIcons(channel = "OOH", type = "cartello") {
  const completePath = channel + "/" + iconName(type) + ".svg";
  return CDNUrl + "/alessi/icons/systems/" + completePath
}

function getSystemsMarkers(channel = "OOH", type = "cartello", status = "active") {
  let completePath = "";
  if (type === "tiny-markers") {
    completePath = type + "/" + status + ".svg";
  } else {
    completePath = channel + "/" + iconName(type) + "/" + status + ".svg";
  }
  return CDNUrl + "/alessi/icons/markers/systems/" + completePath
}

function getPlanningsMarkers(channel = "OOH", type = "cartello", status = "available") {
  let completePath = "";
  if (type === "tiny-markers") {
    completePath = type + "/" + status + ".svg";
  } else {
    completePath = channel + "/" + iconName(type) + "/" + status + ".svg";
  }

  return CDNUrl + "/alessi/icons/markers/plannings/" + completePath
}

function getClusterIcon() {
  return CDNUrl + "/alessi/icons/markers/cluster/blue.svg";
}